module.exports = __webpack_public_path__ + "static/media/FramePuzzlePrizes2.5a4528c2.png";